<div class="container-fluid">

  <div class="row mb-2">
    <div class="sub-header">Configure your store</div>
    <br />
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{'onboarding.select_location' | translate}}:
      <span class="help fa hubtiger-tooltip" pTooltip="{{'onboarding.select_shop_info' | translate}}"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="locations" [(ngModel)]="config.LocationID" (onChange)="updateConfig()"
                    placeholder="{{'onboarding.select_shop' | translate}}">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row margin-top-8">
    <div class="col-md-4 label">
      Price Level:
      <span class="help fa hubtiger-tooltip" pTooltip="Price Level configured in Teamwork"></span>
    </div>
    <div class="col-md-8">
      <div class="p-inputgroup">
        <span class="p-inputgroup-addon"><i class="fa fa-home"></i></span>
        <p-dropdown [options]="priceLevels" [(ngModel)]="config.PriceLevelID" (onChange)="updateConfig()"
                    placeholder="Select the price level you use">
        </p-dropdown>
      </div>
    </div>
  </div>
  <div class="row mb-2" style="padding-top:30px"></div>
  <div class="row mb-2">
    <!--<div class="col-12" style="text-align: right;">
        <hub-button [icon]="'plus'" [size]="'xl'" [style]="'outline'" (buttonClick)="addDefault">
        </hub-button>
    </div>-->
    <div class="sub-header">Configure your tax rates</div>
    <br />
  </div>

  <p-table [value]="defaults" id="tblData">
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 200px;">{{'bikeshop.shop_profile.vat_rate' | translate}}</th>
        <th style="width: 100px;">%</th>
        <th style="width: 140px; text-align: center;"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
      <tr>
        <td pEditableColumn style="cursor:pointer;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" [(ngModel)]="row.CategoryID" placeholder="{{ 'general.name' | translate}}" tyle="cursor:pointer;" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ row.CategoryID || '-' }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td pEditableColumn style="cursor:pointer;">
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="number" [(ngModel)]="row.Rate" placeholder="%" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ row.Rate  }}
            </ng-template>
          </p-cellEditor>
        </td>
        <td style="text-align: right;">
          <div>
            <hub-button *ngIf="row.CategoryID !== '' && row.Rate !== '' " [icon]="'upload'" [size]="'xl'" [style]="'outline'" (buttonClick)="saveDefault(row)"></hub-button>
            <hub-button *ngIf="row.CategoryID == '' && row.Rate == '' " [disabled]="true" [icon]="'upload'" [size]="'xl'" [style]="'outline'" (buttonClick)="saveDefault(row)"></hub-button>
            <hub-button [icon]="'trash'" [size]="'xl'" [style]="'outline'" (buttonClick)="removeDefault(rowIndex, row)"></hub-button>
          </div>
        </td>
      </tr>
    </ng-template>

    <ng-template pTemplate="footer">
      <tr>
        <td colspan="3" style="justify-items: right; border: 0px; ">
          <div class="" style="text-align: right;">
            <hub-button [icon]="'plus'" [size]="'xl'" [style]="'outline'" (buttonClick)="addDefault()" text="{{ 'bikeshop.service_types.add_new' | translate}}">
            </hub-button>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-table>

  <div class="wizard-message box center margin-top-0" *ngIf="message">
    <div [innerHTML]="message"></div>
  </div>
</div>
